/* istanbul ignore file */
export { default } from './CookieConsentBanner';
